import { BodyCopy } from "./BodyCopy";
import { Button } from "lola-framework-ui-test";
import { useTranslation } from "react-i18next";
import { LimitInfoIcon } from "../assets/icons";
import { TITLE_COLOR } from "../constants";
import { useStore } from "../store/globalState";
import { amountFormatter } from "../utils";

export interface AmountOutOfRangeInfoProps {
  ns: string;
  kind: "below_min" | "above_max";
  method: string;
  bound: number;
  currency: string;
  /** Pinned amount (fund-request): change method. Default: change amount. */
  cta?: "gotIt" | "changeAmount" | "changeMethod";
  onClose: () => void;
}

/**
 * Gallery Continuar gate when the send amount is outside the funding-method min/max.
 */
export const AmountOutOfRangeInfo: React.FC<AmountOutOfRangeInfoProps> = ({
  ns,
  kind,
  method,
  bound,
  currency,
  cta = "changeAmount",
  onClose,
}) => {
  const { t } = useTranslation(ns);
  const { theme } = useStore();
  const colorConfig = theme.whiteView;
  const { bodyCopy, backgroundBtn, textColorBtn } = colorConfig;

  const number = amountFormatter(bound, currency, {
    minimumFractionDigits: Number.isInteger(bound) ? 0 : 2,
    maximumFractionDigits: Number.isInteger(bound) ? 0 : 2,
  });
  const formatted = currency.toUpperCase() === "USD" ? `$${number}` : number;

  const message =
    kind === "above_max"
      ? t("amountLimit.aboveMax", { max: formatted, method, currency })
      : t("amountLimit.belowMin", { min: formatted, method, currency });

  return (
    <section className="amount-limit-slot">
      <LimitInfoIcon size={60} colors={[TITLE_COLOR, TITLE_COLOR]} />
      <h2 className="amount-limit-heading" style={{ color: TITLE_COLOR }}>
        {t("amountLimit.title")}
      </h2>
      <BodyCopy className="amount-limit-text" textColor={bodyCopy}>
        {message}
      </BodyCopy>
      <Button
        size="large"
        background={backgroundBtn}
        color={textColorBtn}
        onClick={onClose}
      >
        {t(
          cta === "changeMethod"
            ? "amountLimit.changeMethod"
            : cta === "gotIt"
              ? "amountLimit.gotIt"
              : "amountLimit.changeAmount",
        )}
      </Button>
    </section>
  );
};
